import { gql } from '@apollo/client';

export const EXECUTE_CUTOFF = gql`
    mutation ExecuteCutoff($hubId: Long!, $areaIds: [Long!]!) {
        executeCutoff(hubId: $hubId, areaIds: $areaIds) {
            areaId
            status
            message
        }
    }
`;

export type CutoffResultStatus = 'IN_PROGRESS' | 'FAILED' | 'SKIPPED';

export interface CutoffResultOutput {
    areaId: number;
    status: CutoffResultStatus;
    message: string | null;
}

export interface ExecuteCutoffResponse {
    executeCutoff: CutoffResultOutput[];
}

export interface ExecuteCutoffVariables {
    hubId: number;
    areaIds: number[];
}
